import { render, staticRenderFns } from "./FiliationDetails.vue?vue&type=template&id=863b708c"
import script from "./FiliationDetails.vue?vue&type=script&lang=js"
export * from "./FiliationDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports